import { filterValidDates } from '@/utils/date'

export default defineNuxtRouteMiddleware((to) => {
  // Only clean up on client-side
  if (import.meta.server || !to.query?.['start_dates[]']) return

  const originalDates = to.query['start_dates[]']
  const validDates = filterValidDates(originalDates)
  
  // Check if any dates were filtered out
  const originalCount = Array.isArray(originalDates) ? originalDates.length : 1
  
  if (validDates.length !== originalCount) {
    const newQuery = { ...to.query }
    
    if (validDates.length === 0) {
      delete newQuery['start_dates[]']
    } else {
      newQuery['start_dates[]'] = validDates.length === 1 ? validDates[0] : validDates
    }
    
    return navigateTo({ path: to.path, query: newQuery }, { replace: true })
  }
})